import React from "react";
import { Box, makeStyles, useTheme } from "@material-ui/core";
import { randomColor } from "../../utils/randomColor";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        questionBox: (_a = {
                display: "flex",
                justifyContent: "start",
                width: "100%",
                height: "98px",
                padding: "24px 38px 22px 24px",
                opacity: 0.8,
                borderRadius: "4px",
                background: function (props) { return "".concat(props["bgColor"]) || theme.palette.InfoCard.backgroundColor; }
            },
            _a[theme.breakpoints.down("sm")] = {
                maxWidth: "100%"
            },
            _a),
        title: {
            fontSize: "15px",
            fontFamily: "var(--openSans)",
            fontWeight: "normal",
            lineHeight: 1.33,
            letterSpacing: "normal",
            color: theme.palette.InfoCard.titleColor,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
        },
        text: {
            fontFamily: "var(--poppins)",
            fontSize: "26px",
            fontWeight: 700,
            lineHeight: 1.23,
            letterSpacing: "normal",
            color: theme.palette.InfoCard.textColor,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }
    });
});
var InfoBlock = function (_a) {
    var _b = _a.customBgColor, customBgColor = _b === void 0 ? "" : _b, iconBgColor = _a.iconBgColor, IconSvg = _a.IconSvg, title = _a.title, text = _a.text, containerCustomStyle = _a.containerCustomStyle, titleCustomStyle = _a.titleCustomStyle, textCustomStyle = _a.textCustomStyle, textContainerCustomStyle = _a.textContainerCustomStyle, _c = _a.streth, streth = _c === void 0 ? false : _c;
    var theme = useTheme();
    var classes = useStyles({ bgColor: customBgColor ? customBgColor : randomColor() });
    return (React.createElement(Box, { className: classes.questionBox, style: containerCustomStyle, maxWidth: streth ? "100%" : "260px" },
        IconSvg && (React.createElement(Box, { mr: 2 },
            React.createElement(IconSvg, { fill: iconBgColor || theme.palette.InfoCard.iconColor }))),
        React.createElement(Box, { style: textContainerCustomStyle },
            React.createElement(Box, { className: classes.title, style: titleCustomStyle }, title),
            React.createElement(Box, { className: classes.text, style: textCustomStyle }, text || "0"))));
};
export default InfoBlock;
//# sourceMappingURL=InfoBlock.js.map